/* tslint:disable:no-shadowed-variable */
import camelcaseKeysDeep from 'camelcase-keys-deep'
import { ModuleNames } from '@/store/module-names'
import { PatientWithActigraphyReportState } from './types'
import { ActionNames, MutationNames } from './keys'
import { getters } from './getters'
import {
  getPatientWithActigraphyReportsById,
  GetPatientWithActigraphyReportsByIdDto,
} from '@/jsonapi/PatientWithActigraphyReports'

const state: PatientWithActigraphyReportState = {
  patientWithActigraphyReports: [],
}

const mutations = {
  [MutationNames.updatePatientWithActigraphyReports](state: PatientWithActigraphyReportState, payload): void {
    state.patientWithActigraphyReports = payload
  },
}

const actions = {
  async [ActionNames.getPatientWithActigraphyReportsById](
    { commit, state },
    payload: GetPatientWithActigraphyReportsByIdDto
  ): Promise<void> {
    const results = camelcaseKeysDeep(await getPatientWithActigraphyReportsById(payload))

    // Currently, actually doesn't refer this state, they are managing this info in their local state
    // const newReports = addOrUpdateSameKeyObjectInArray(state.patientWithActigraphyReports, results[0], 'id')
    // commit(MutationNames.updatePatientWithActigraphyReports, newReports)

    return results[0]
  },
}

export default {
  name: ModuleNames.patientWithActigraphyReports,
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
